var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightenImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 15,
    transform: "matrix(-1 8.74228e-08 8.74228e-08 1 84 0)",
    fill: "#FEBF88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightenImg2);
export default __webpack_public_path__ + "static/media/brighten-img-2.4662b3b272e20d62e9b252b8328b4a2e.svg";
export { ForwardRef as ReactComponent };